import { reactSelectStyles } from "ui/CreatableSelect";
import React from "react";
import ReactSelect from "react-select";

export type OptionGroup<T> = {
  label: string;
  options: T[];
};
type OptionsOrGroups<T> = T[] | OptionGroup<T>[];

type MultiProps<T> = {
  value: T[] | null;
  options: OptionsOrGroups<T>;
  onChange: (selected: T[] | null) => void;
  placeholder?: React.ReactNode;
  isClearable?: boolean;
  isDisabled?: boolean;
  onFocus?: (event: any) => void;
  onBlur?: (event: any) => void;
  ariaLabel?: string;
};

export function MultiSelect<T>({
  value,
  options,
  onChange,
  placeholder,
  isClearable,
  isDisabled,
  onFocus,
  onBlur,
  ariaLabel,
}: MultiProps<T>): React.ReactElement {
  return (
    <ReactSelect
      value={value}
      options={options}
      onChange={onChange}
      isClearable={isClearable}
      placeholder={placeholder}
      isDisabled={isDisabled}
      onFocus={onFocus}
      onBlur={onBlur}
      styles={reactSelectStyles}
      isMulti
      aria-label={ariaLabel}
    />
  );
}

export default MultiSelect;
